<template>
	<div class="PersonalCenter">
		<!-- 面包屑 -->
		<div class="Breadcrumb">
			<img src="~@img/icon/ui_home_page_0.png" alt />
			<a @click="$router.push('/Layout/Home')">首页 &nbsp;/ &nbsp;</a>
			<a class="active">个人信息</a>
		</div>
		<!-- 内容 -->
		<div class="contain">
			<p class="title">个人中心</p>
			<div class="infoarea">
				<div style="width:592px">
					<p class="title">
						<img src="~@img/icon/ui_grxx.png" alt />个人信息
					</p>
					<p>
						<span>姓 名：</span>
						{{personalinfo.name}}
					</p>
					<p>
						<span>学 号：</span>
						{{personalinfo.number}}
					</p>
					<p>
						<span>分 组：</span>
						<!-- {{['','',''][personalinfo.groups]}} -->
						<span class="laber">{{ ['初', '中', '高'][personalinfo.groups] }}级组</span>
					</p>
					<p style="margin-bottom:20px">
						<span>密 码：</span>
						<a style="color:#FFA216" @click="editdialog=true">修改密码</a>
					</p>
					<p class="title">
						<img src="~@img/icon/ui_sybg.png" alt />实验报告
					</p>
					<p>
						<span>提交状况：</span>
						{{personalinfo.reportStatus==1?'已提交':'未提交'}}
					</p>
					<p>
						<span>报告评分：</span>
						{{personalinfo.reportStatus==1? personalinfo.reportScore:'无'}}
					</p>
					<div style="height:150px;overflow:hidden;overflow-y:auto;">
						<p>
							<span>报告评语：</span>
							{{personalinfo.reportStatus==1? personalinfo.reportComment:'无'}}
						</p>
					</div>

					<div class="btns" style="margin-bottom:10px">
						<div class="divbtn" v-if="personalinfo.reportStatus==0">
							<input type="file" @change="change" placeholder="提交报告" accept=".doc, .docx" />
						</div>
						<button v-if="personalinfo.reportStatus==1" @click="downFile">下载报告</button>
					</div>
					<p class="docarea" v-if="personalinfo.reportStatus==1">
						<img src="~@img/icon/ui_word_document.png" alt />
						{{personalinfo.reportName}}
					</p>
				</div>

				<div style="width:592px">
					<p class="title">
						<img src="~@img/icon/ui_khpf.png" alt />考核评分
					</p>
					<p class="totalscore">
						<span>总分：</span> 
						{{personalinfo.totalScore>0? personalinfo.totalScore+'分':'无'}}
					</p>
					<p>
						<span style="letter-spacing:7px;">线上虚拟实验操作</span><span>：</span>
						{{personalinfo.onlineScore>0? personalinfo.onlineScore+'分':'无'}}
					</p>
					<p>
						<span style="letter-spacing:25px;">技术评定分</span><span>：</span>
						{{personalinfo.autoScore>0? personalinfo.autoScore+'分':'无'}}
					</p>
					<p>
						<span style="letter-spacing:25px;">技术达标分</span><span>：</span>
						{{personalinfo.testScore>0? personalinfo.testScore+'分':'无'}}
					</p>
					<p>
						<span style="letter-spacing:1px;">线下自主训练完成情况</span><span>：</span>
						{{personalinfo.offlineScore>0? personalinfo.offlineScore+'分':'无'}}
					</p>
				</div>

				<div style="width:402px">
					<div class="infotips">
						<p class="title">关于个人信息：</p>
						<p>若个人信息错误，或需要重置密码，请联系任课老师帮忙修改。</p>

						<div style="height:1px;background:#FFA216;margin:29px 0"></div>

						<p class="title">关于考试成绩分数占比：</p>
						<p>线上虚拟实验操作（{{(personalinfo.examNormDO.online*100).toFixed(0)}}%）</p>
						<p>技术评定分（{{(personalinfo.examNormDO.auto*100).toFixed(0)}}%）</p>
						<p>技术达标分（{{(personalinfo.examNormDO.test*100).toFixed(0)}}%）</p>
						<p>线下自主训练完成情况（{{(personalinfo.examNormDO.offline*100).toFixed(0)}}%）</p>
					</div>
				</div>
			</div>
		</div>

		<!-- 编辑弹窗 -->
		<editDialog v-model="editdialog" @close="editdialog=false">
			<div class="editcon">
				<p class="title">修改密码</p>
				<p class="label">请输入原始密码：</p>
				<input type="password" v-model="editparams.password" />
				<p class="label">请输入新密码：</p>
				<input type="password" v-model="editparams.newPassword" />
				<p class="label">再次输入新密码：</p>
				<input type="password" v-model="newPassword" />
				<p class="errinfo" id="errinfo">&nbsp;</p>
				<div class="btns">
					<button @click="cancelEdit">取 消</button>
					<button @click="sureEdit">确 认</button>
				</div>
			</div>
		</editDialog>
	</div>
</template>

<script>
import editDialog from "@/components/dialog/popup.vue";
export default {
	name: "PersonalCenter",
	components: {
		editDialog,
	},
	data() {
		return {
			editdialog: false,
			// 个人信息
			personalinfo: {},
			// 二次确认密码
			newPassword: undefined,
			// 修改密码
			editparams: {
				password: undefined,
				newPassword: undefined,
			},
		};
	},
	mounted() {
		// get http://127.0.0.1:8018/jump//jump/api/user/info
		this.getUserInfo();
	},
	methods: {
		// 修改密码
		async sureEdit() {
			const errorinfo = document.getElementById("errinfo");
			let { newPassword } = this.editparams;
			console.log(newPassword != this.newPassword);
			if (newPassword != this.newPassword) {
				errorinfo.innerText = "新密码输入有误";
				return;
			}
			try {
				const res = await this.$http
					.get("api/user/updatePassword", {
						params: { ...this.editparams },
					})
					.then((res) => {
						console.log("res", res);
						if (res.success) {
							this.editdialog = false;
							this.$message.success(res.message);
							this.editparams.password = undefined;
							this.editparams.newPassword = undefined;
							this.newPassword = undefined;
						}
					});
			} catch {
				errorinfo.innerText = "请输入正确的密码";
			}
		},
		cancelEdit() {
			this.editparams.password = undefined;
			this.editparams.newPassword = undefined;
			this.newPassword = undefined;
			this.editdialog = false;
		},

		async getUserInfo() {
			const res = await this.$http.get("api/user/info");
			this.personalinfo = res.result;
		},

		// 提交报告
		async change(event) {
			let formData = new FormData();
			formData.append("file", event.target.files[0]);
			await this.$http.post("api/user/submitReport", formData);
		},

		downFile() {
			let fileUrl = this.personalinfo.reportFile;
			let fileName = this.personalinfo.reportName;
			this.$axios({
				method: "GET",
				url: fileUrl,
				// data: data,
				// params: data,
				responseType: "blob", //返回是个文件
			}).then((response) => {
				console.log('file',response);
				this.downloadFile(response,fileName); //then直接下载，方法在下边
			});
		},
		// 下载文件
		downloadFile(res,fileName) {
			let blob = new Blob([res], {
				type: "application/msword",
			}); //type是文件类，详情可以参阅blob文件类型
			// 创建新的URL并指向File对象或者Blob对象的地址
			const blobURL = window.URL.createObjectURL(blob);
			// 创建a标签，用于跳转至下载链接
			const tempLink = document.createElement("a");
			tempLink.style.display = "none";
			tempLink.href = blobURL;
			tempLink.download = fileName;
			// tempLink.setAttribute(
			// 	"download",
			// 	decodeURI(
			// 		res.headers["content-disposition"]
			// 			.split(";")[1]
			// 			.split("=")[1]
			// 	)
			// );
			// 兼容：某些浏览器不支持HTML5的download属性
			if (typeof tempLink.download === "undefined") {
				tempLink.setAttribute("target", "_blank");
			}
			// 挂载a标签
			document.body.appendChild(tempLink);
			tempLink.click();
			document.body.removeChild(tempLink);
			// 释放blob URL地址
			window.URL.revokeObjectURL(blobURL);
		},
	},
};
</script>

<style lang="less" scoped>
.ant-message-notice-content {
	z-index: 999999999;
	opacity: 1;
}
.PersonalCenter {
	overflow: auto;
	p {
		margin: 0;
	}
	.Breadcrumb {
		width: 100%;
		position: fixed;
		height: 66px;
		background: #fff1d1;
		padding-left: 38px;
		display: flex;
		justify-content: start;
		z-index: 10;
		> img {
			width: 66px;
			height: 66px;
		}
		a {
			line-height: 66px;
			font-size: 25px;
			font-weight: 400;
			color: rgba(0, 0, 0, 0.45);
		}
		a.active {
			color: #ffa216;
		}
	}
	.contain {
		width: 1705px;
		margin: auto;
		overflow: hidden;
		margin-top: 66px;
		margin-bottom: 20px;
		> p.title {
			margin-top: 20px;
			font-size: 40px;
			line-height: 48px;
			font-weight: bold;
			color: #ffffff;
			-webkit-text-stroke: 2px #ffa216;
			border-left: 6px solid #ffa216;
			border-radius: 1px;
			padding-left: 16px;
			letter-spacing: 2px;
		}
		.infoarea {
			padding: 17px;
			margin-top: 20px;
			width: 1705px;
			height: 740px;
			background: #ffffff;
			border: 1px solid #c0c0c0;
			border-radius: 5px;
			display: flex;
			justify-content: space-between;
			p.title {
				line-height: 60px;
				font-size: 25px;
				font-weight: bold;
				color: #ffa216;
				background: #fff1d1;
				opacity: 1;
				border-radius: 5px;
				display: flex;
				align-items: center;
				img {
					margin: 0 15px 0 17px;
					width: 30px;
					height: 30px;
				}
			}
			p.totalscore {
				font-size: 33px;
				line-height: 70px;
				font-weight: bold;
				color: #ffa216;
			}
			p {
				font-size: 22px;
				font-weight: 400;
				line-height: 49px;
				color: #313131;
				span {
					font-weight: bold;
				}
			}
			.docarea {
				line-height: 40px;
				display: flex;
				align-items: center;
				font-size: 20px;
				img {
					width: 30px;
					height: 30px;
				}
			}
			.docarea:hover {
				cursor: pointer;
			}
			.infotips {
				box-sizing: border-box;
				width: 402px;
				height: 100%;
				background: rgba(255, 241, 209, 0.3);
				border: 1px solid #ffa216;
				opacity: 1;
				border-radius: 5px;
				padding: 24px;
				p {
					background: none;
					font-size: 22px;
					font-weight: 400;
					line-height: 49px;
					color: #ffa216;
				}
				.title {
					box-sizing: border-box;
					font-size: 22px;
					font-weight: bold;
					line-height: 49px;
					color: #ffa216;
				}
			}

			span.laber {
				font-size: 18px;
				font-weight: 400;
				line-height: 13px;
				color: #ffb900;
				background: rgba(254, 196, 51, 0.2);
				padding: 4px 12px;
				border-radius: 100vw;
				// margin-top: 8 / @rem;
			}
		}
		.btns {
			margin-top: 19px;
			display: flex;
			justify-content: start;
			button {
				width: 169px;
				height: 57px;
				font-size: 25px;
				font-family: PingFang SC;
				color: #ffffff;
				background: linear-gradient(to right, #fec937, #ff9900);
				text-shadow: 0px 1px 2px rgba(129, 35, 0, 0.3);
				border: none;
				border-radius: 4px;
			}
		}
	}
}

.editcon {
	width: 510px;
	height: 410px;
	background: #ffffff;
	font-family: PingFang SC;
	border-radius: 5px;
	padding: 24px 61px;
	input {
		width: 100%;
		height: 32px;
		border: 1px solid #d9d9d9;
		outline: none;
	}
	.title {
		text-align: center;
		font-size: 22px;
		line-height: 30px;
		color: #313131;
		margin-bottom: 25px;
	}
	.label {
		font-size: 18px;
		line-height: 30px;
		color: #313131;
		line-height: 20px;
		margin-top: 20px;
	}
	.errinfo {
		color: red;
		text-align: center;
		font-size: 16px;
		line-height: 16px;
	}
	.btns {
		margin-top: 15px;
		display: flex;
		justify-content: space-around;
		.button {
			background: red;
		}
		button {
			width: 128px;
			height: 40px;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #ffffff;
			text-shadow: 0px 1px 2px rgba(129, 35, 0, 0.3);
			text-shadow: 0px 1px 2px rgba(129, 35, 0, 0.3);
			border: none;
			border-radius: 4px;
			input {
				width: 128px;
				height: 40px;
			}
		}
		button:hover {
			box-shadow: 0px 0px 6px #fec633;
		}
		button:nth-child(1) {
			color: #ffa216;
			border: 1px solid #ffa216;
			background: #ffffff;
		}
		button:nth-child(2) {
			background: linear-gradient(to right, #fec937, #ff9900);
		}
	}
}
</style>
